// Core Components
import React from 'react';

import makeStyles from '@mui/styles/makeStyles';
import HelpIcon from '@mui/icons-material/Help';

const useStyles = makeStyles((theme) => ({
  titleBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    margin: theme.spacing(1),
  },
}));

export default function PageTitle(props) {
  const classes = useStyles();
  const { Icon, title } = props;
  const TitleIcon = Icon ? Icon : HelpIcon;

  return (
    <div className={classes.titleBox}>
      <TitleIcon className={classes.icon} />
      {title}
    </div>
  );
}
